/**
 * @generated SignedSource<<45440f530542a8c6b09e5a27bee61542>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdatePortalUserInput = {
  clientOrgId: string;
  userId: string;
  roleKey?: string | null;
  email?: string | null;
  scopeLevel?: string | null;
  scopeProgrammeIds?: ReadonlyArray<string | null> | null;
  scopeProjectIds?: ReadonlyArray<string | null> | null;
  deactivated?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updatePortalUserMutation$variables = {
  input: UpdatePortalUserInput;
};
export type updatePortalUserMutation$data = {
  readonly updatePortalUser: {
    readonly portalUsers: ReadonlyArray<{
      readonly id: string | null;
      readonly email: string | null;
      readonly roleKey: string | null;
      readonly status: string | null;
      readonly scopeLevel: string | null;
      readonly scopeProgrammeIds: ReadonlyArray<string | null> | null;
      readonly scopeProjectIds: ReadonlyArray<string | null> | null;
    } | null> | null;
  } | null;
};
export type updatePortalUserMutation = {
  variables: updatePortalUserMutation$variables;
  response: updatePortalUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdatePortalUserPayload",
    "kind": "LinkedField",
    "name": "updatePortalUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PortalUser",
        "kind": "LinkedField",
        "name": "portalUsers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roleKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopeLevel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopeProgrammeIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopeProjectIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePortalUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePortalUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dc118708325894a5ea10b8b3105765bc",
    "id": null,
    "metadata": {},
    "name": "updatePortalUserMutation",
    "operationKind": "mutation",
    "text": "mutation updatePortalUserMutation(\n  $input: UpdatePortalUserInput!\n) {\n  updatePortalUser(input: $input) {\n    portalUsers {\n      id\n      email\n      roleKey\n      status\n      scopeLevel\n      scopeProgrammeIds\n      scopeProjectIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bcba266f47653b11f85d83fd6eb89960";

export default node;
